import React from "react";
import { FormLabel } from "newui/components/ui/FormLabel";
import InfoTooltip from "newui/components/InfoTooltip";
import FormikFieldError from "newui/components/ui/FormikFieldError";
import { ImageTile } from "./components/ImageTile";

export interface ImagePreviewBaseProps {
	className?: string;
	errorText?: string;
	guideLine?: string;
	hasError?: boolean;
	label?: string;
	modalTitleOverride?: string;
	required?: boolean;
	showFileInfo?: boolean;
	testId?: string;
}

interface ImagePreviewProps extends ImagePreviewBaseProps {
	image: File | string | null;
	onChange: (file: File | null) => void;
}

export const ImagePreview: React.FC<ImagePreviewProps> = ({
	label,
	required,
	guideLine,
	className = "",
	image,
	onChange,
	hasError = false,
	errorText,
	testId,
	showFileInfo = true,
}) => (
	<div className={className} data-testid={testId}>
		{label && (
			<FormLabel label={label} required={required}>
				{guideLine && (
					<div className="inline-block">
						<InfoTooltip tooltipText={guideLine} />
					</div>
				)}
			</FormLabel>
		)}

		<div
			className="cursor-pointer"
			onDragOver={(e) => e.preventDefault()}
			onDrop={(e) => e.preventDefault()}
		>
			<ImageTile
				image={image}
				onChange={onChange}
				label={label}
				hasError={hasError}
				showFileInfo={showFileInfo}
			/>
		</div>

		<FormikFieldError text={hasError ? errorText : undefined} />
	</div>
);
